/** `debts` module DTOs unique keys */
export enum DebtsDtoKeysEnum {
  /** Cash gap report items API query parameters */
  CASH_GAP_ITEMS_QUERY_DTO = 'debts/cash-gap-items-query.dto',
  /** Cash gap report registry export to file API query parameters */
  CASH_GAP_EXPORT_QUERY_DTO = 'debts/cash-gap-export-query.dto',
  /** Cash gap registry column selection */
  CASH_GAP_SELECT_DTO = 'debts/cash-gap-select.dto',
  /** Cash gap registry column selection per `byMonths` mode */
  CASH_GAP_SELECT_BY_MODE_DTO = 'debts/cash-gap-select-by-mode.dto',
  /** Cash gap report own filters */
  CASH_GAP_OWN_FILTERS_DTO = 'debts/cash-gap-own-filters.dto',
  /** Cash gap report plot API query parameters */
  CASH_GAP_PLOT_QUERY_DTO = 'debts/cash-gap-plot-query.dto',
  /** Cash gap report plot API own settings */
  CASH_GAP_PLOT_SETTINGS_DTO = 'debts/cash-gap-plot-settings.dto',
  /** Cash gap subtotal own filters */
  CASH_GAP_SUBTOTAL_BY_DTO = 'debts/cash-gap-subtotal-by.dto',
  /** Cash gap subtotal API query parameters */
  CASH_GAP_SUBTOTAL_QUERY_DTO = 'debts/cash-gap-subtotal-query.dto',
  /** Cash gap report amount base data */
  CASH_GAP_AMOUNT_DTO = 'debts/cash-gap-amount.dto',
  /** Cash gap report item - cash gap data for single counterparty at single date */
  CASH_GAP_REPORT_ITEM_DTO = 'debts/cash-gap-report-item.dto',
  /** Cash gap report JSON-"page" response body */
  CASH_GAP_REPORT_PAGE_DTO = 'debts/cash-gap-report-page.dto',
  /** Cash gap report sorting settings */
  CASH_GAP_SORT_DTO = 'debts/cash-gap-sort.dto',
  /** Cash gap report subtotal list item */
  CASH_GAP_SUBTOTAL_ITEM_DTO = 'debts/cash-gap-subtotal-item.dto',
  /** Cash gap report subtotal data */
  CASH_GAP_SUBTOTAL_DTO = 'debts/cash-gap-subtotal.dto',
  /** Cash gap report total API query parameters */
  CASH_GAP_TOTAL_QUERY_DTO = 'debts/cash-gap-total-query.dto',
  /** Cash gap report total values */
  CASH_GAP_TOTAL_VALUES_DTO = 'debts/cash-gap-total-values.dto',
  /** Cash gap report total API response body */
  CASH_GAP_TOTAL_DTO = 'debts/cash-gap-total.dto',
  /** Credit/Debit reports' APIs bills group response body */
  CREDIT_DEBIT_REPORT_BILL_GROUP_DTO = 'debts/credit-debit-report-bill-group.dto',
  /** Credit/debit reports' APIs response body (registry page) */
  CREDIT_DEBIT_REPORT_PAGE_DTO = 'debts/credit-debit-report-page.dto',
  /** Credit/debit reports' APIs item */
  CREDIT_DEBIT_REPORT_ITEM_DTO = 'debts/credit-debit-report-item.dto',
  /** Credit/debit reports' own filters */
  CREDIT_DEBIT_REPORT_OWN_FILTERS_DTO = 'debts/credit-debit-report-own-filters.dto',
  /** Credit/debit reports' APIs query parameters */
  CREDIT_DEBIT_REPORT_QUERY_DTO = 'debts/credit-debit-report-query.dto',
  /** Debtors report registry export to file API query parameters */
  CREDIT_DEBIT_REPORT_EXPORT_QUERY_DTO = 'debts/credit-debit-report-export-query.dto',
  /** Credit/debit registry column selection */
  CREDIT_DEBIT_REPORT_SELECT_DTO = 'debts/credit-debit-report-select.dto',
  /** Credit/debit subtotal own filters */
  CREDIT_DEBIT_SUBTOTAL_BY_DTO = 'debts/credit-debit-subtotal-by.dto',
  /** Credit/debit subtotal API query parameters */
  CREDIT_DEBIT_SUBTOTAL_QUERY_DTO = 'debts/credit-debit-subtotal-query.dto',
  /** Credit/debit report subtotal list item */
  CREDIT_DEBIT_SUBTOTAL_ITEM_DTO = 'debts/credit-debit-subtotal-item.dto',
  /** Credit/debit report subtotal data */
  CREDIT_DEBIT_SUBTOTAL_DTO = 'debts/credit-debit-subtotal.dto',
  /** Credit/debit report APIs total values */
  CREDIT_DEBIT_REPORT_TOTAL_DTO = 'debts/credit-debit-report-total.dto',
  /** Credit/Debit dynamics report APIs common filters */
  CREDIT_DEBIT_DYNAMICS_FILTERS_DTO = 'debts/credit-debit-dynamics-filters.dto',
  /** Credit/Debit dynamics report items sub-API item */
  CREDIT_DEBIT_DYNAMICS_ITEM_DTO = 'debts/credit-debit-dynamics-item.dto',
  /** Credit/Debit dynamics report items sub-API response body */
  CREDIT_DEBIT_DYNAMICS_ITEMS_PAGE_DTO = 'debts/credit-debit-dynamics-items-page.dto',
  /** Credit/Debit dynamics report items sub-API query parameters */
  CREDIT_DEBIT_DYNAMICS_ITEMS_QUERY_DTO = 'debts/credit-debit-dynamics-items-query.dto',
  /** Credit/Debit dynamics report items sub-API own settings */
  CREDIT_DEBIT_DYNAMICS_ITEMS_SETTINGS_DTO = 'debts/credit-debit-dynamics-items-settings.dto',
  /** Credit/Debit dynamics registry export to file API query parameters */
  CREDIT_DEBIT_DYNAMICS_EXPORT_QUERY_DTO = 'debts/credit-debit-dynamics-export-query.dto',
  /** Credit/Debit dynamics registry export URL parameters (`itemType` + `format`) */
  CREDIT_DEBIT_DYNAMICS_EXPORT_PARAMS_DTO = 'debts/credit-debit-dynamics-export-params.dto',
  /** Credit/Debit dynamics report APIs common URL parameters */
  CREDIT_DEBIT_DYNAMICS_PARAMS_DTO = 'document/credit-debit-dynamics-params.dto',
  /** Credit/Debit dynamics report plot sub-API query parameters */
  CREDIT_DEBIT_DYNAMICS_PLOT_QUERY_DTO = 'document/credit-debit-dynamics-plot-query.dto',
  /** Credit/Debit dynamics report plot sub-API own settings */
  CREDIT_DEBIT_DYNAMICS_PLOT_SETTINGS_DTO = 'document/credit-debit-dynamics-plot-settings.dto',
  /** Customer debt entry response body */
  CUSTOMER_DEBT_FIND_DTO = 'debts/customer-debt-find.dto',
  /** "Debts" module settings common DTO */
  DEBTS_SETTINGS_DTO = 'debts/debts-settings.dto',
  /** Debt collection task create API request body */
  DEBT_COLLECTION_TASK_CREATE_DTO = 'debts/debt-collection-task-create.dto',
  /** Debt collection task find many API query parameters */
  DEBT_COLLECTION_TASK_FIND_MANY_QUERY_DTO = 'debts/debt-collection-task-find-many-query.dto',
  /** Debt collection task export to file API query parameters */
  DEBT_COLLECTION_TASK_EXPORT_QUERY_DTO = 'debts/debt-collection-task-export-query.dto',
  /** Debt collection task find one API query parameters */
  DEBT_COLLECTION_TASK_FIND_ONE_QUERY_DTO = 'debts/debt-collection-task-find-one-query.dto',
  /** Debt collection task response body */
  DEBT_COLLECTION_TASK_FIND_DTO = 'debts/debt-collection-task-find.dto',
  /** Debt collection task update API request body */
  DEBT_COLLECTION_TASK_FORM_DTO = 'debts/debt-collection-task-form.dto',
  /** Debt collection task own filters for list API */
  DEBT_COLLECTION_TASK_OWN_FILTERS_DTO = 'debts/debt-collection-task-own-filters.dto',
  /** Debt collection task find many API response body */
  DEBT_COLLECTION_TASK_PAGE_DTO = 'debts/debt-collection-task-page.dto',
  /** Debt collection task partial update API request body */
  DEBT_COLLECTION_TASK_PARTIAL_FORM_DTO = 'debts/debt-collection-task-partial-form.dto',
  /** Debt collection task selection options */
  DEBT_COLLECTION_TASK_SELECT_DTO = 'debts/debt-collection-task-select.dto',
  /** Debt collection task find-one selection options (card defaults) */
  DEBT_COLLECTION_TASK_FIND_ONE_SELECT_DTO = 'debts/debt-collection-task-find-one-select.dto',
  /** Debt collection task sorting options */
  DEBT_COLLECTION_TASK_SORT_DTO = 'debts/debt-collection-task-sort.dto',
  /** Debt collection task status switch API request body */
  DEBT_COLLECTION_TASK_SWITCH_STATUS_DTO = 'debts/debt-collection-task-switch-status.dto',
  /** Debt collection task event create API request body */
  DEBT_COLLECTION_TASK_EVENT_CREATE_DTO = 'debts/debt-collection-task-event-create.dto',
  /** Debt collection task event find many API query parameters */
  DEBT_COLLECTION_TASK_EVENT_FIND_MANY_QUERY_DTO = 'debts/debt-collection-task-event-find-many-query.dto',
  /** Debt collection task event find one API query parameters */
  DEBT_COLLECTION_TASK_EVENT_FIND_ONE_QUERY_DTO = 'debts/debt-collection-task-event-find-one-query.dto',
  /** Debt collection task event response body */
  DEBT_COLLECTION_TASK_EVENT_FIND_DTO = 'debts/debt-collection-task-event-find.dto',
  /** Debt collection task event update API request body */
  DEBT_COLLECTION_TASK_EVENT_FORM_DTO = 'debts/debt-collection-task-event-form.dto',
  /** Debt collection task event find many API own filters */
  DEBT_COLLECTION_TASK_EVENT_OWN_FILTERS_DTO = 'debts/debt-collection-task-event-own-filters.dto',
  /** Debt collection task event find many API response body */
  DEBT_COLLECTION_TASK_EVENT_PAGE_DTO = 'debts/debt-collection-task-event-page.dto',
  /** Debt collection task event partial update API request body */
  DEBT_COLLECTION_TASK_EVENT_PARTIAL_FORM_DTO = 'debts/debt-collection-task-event-partial-form.dto',
  /** Debt collection task event selection settings */
  DEBT_COLLECTION_TASK_EVENT_SELECT_DTO = 'debts/debt-collection-task-event-select.dto',
  /** Debt collection task event sorting settings */
  DEBT_COLLECTION_TASK_EVENT_SORT_DTO = 'debts/debt-collection-task-event-sort.dto',
  /** Debt collection task event status switch API request body */
  DEBT_COLLECTION_TASK_EVENT_SWITCH_STATUS_DTO = 'debts/debt-collection-task-event-switch-status.dto',
  /** Debt collection task event type find many API query parameters */
  DEBT_COLLECTION_TASK_EVENT_TYPE_FIND_MANY_QUERY_DTO = 'debts/debt-collection-task-event-type-find-many-query.dto',
  /** Debt collection task event type find one API query parameters */
  DEBT_COLLECTION_TASK_EVENT_TYPE_FIND_ONE_QUERY_DTO = 'debts/debt-collection-task-event-type-find-one-query.dto',
  /** Debt collection task event type response body */
  DEBT_COLLECTION_TASK_EVENT_TYPE_FIND_DTO = 'debts/debt-collection-task-event-type-find.dto',
  /** Debt collection task event type create and update APIs request body */
  DEBT_COLLECTION_TASK_EVENT_TYPE_FORM_DTO = 'debts/debt-collection-task-event-type-form.dto',
  /** Debt collection task event type find many API response body */
  DEBT_COLLECTION_TASK_EVENT_TYPE_PAGE_DTO = 'debts/debt-collection-task-event-type-page.dto',
  /** Debt collection task event type partial update API request body */
  DEBT_COLLECTION_TASK_EVENT_TYPE_PARTIAL_FORM_DTO = 'debts/debt-collection-task-event-type-partial-form.dto',
  /** Debt collection task event type selection settings */
  DEBT_COLLECTION_TASK_EVENT_TYPE_SELECT_DTO = 'debts/debt-collection-task-event-type-select.dto',
  /** Debt collection task event type sorting settings */
  DEBT_COLLECTION_TASK_EVENT_TYPE_SORT_DTO = 'debts/debt-collection-task-event-type-sort.dto',
  /** Debt collection task analytics widget documents analytics entry */
  DEBT_COLLECTION_TASK_ANALYTICS_DOCUMENTS_DTO = 'debts/debt-collection-task-analytics-documents.dto',
  /** Debt collection task analytics widget API response body */
  DEBT_COLLECTION_TASK_ANALYTICS_DTO = 'debts/debt-collection-task-analytics.dto',
  /** Debt collection task subtotal own filters */
  DEBT_COLLECTION_TASK_SUBTOTAL_BY_DTO = 'debts/debt-collection-task-subtotal-by.dto',
  /** Debt collection task subtotal API query parameters */
  DEBT_COLLECTION_TASK_SUBTOTAL_QUERY_DTO = 'debts/debt-collection-task-subtotal-query.dto',
  /** Debt collection task report subtotal list item */
  DEBT_COLLECTION_TASK_SUBTOTAL_ITEM_DTO = 'debts/debt-collection-task-subtotal-item.dto',
  /** Debt collection task report subtotal data */
  DEBT_COLLECTION_TASK_SUBTOTAL_DTO = 'debts/debt-collection-task-subtotal.dto',
  /** Debt collection task registry total values */
  DEBT_COLLECTION_TASK_REGISTRY_TOTAL_VALUES_DTO = 'debts/debt-collection-task-registry-total-values.dto',
  /** Debt collection task registry total API response body */
  DEBT_COLLECTION_TASK_REGISTRY_TOTAL_DTO = 'debts/debt-collection-task-registry-total.dto',
}
